


















import { SubjectBlock } from '@/views/Subjects.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';
import SubjectLoading from '@/components/subjects/SubjectLoading.vue';
import SubjectComponent from '@/components/subjects/SubjectComponent.vue';
import { SubjectType } from '@/resource/subject/subject.model';

@Component({
  components: {
    SubjectLoading,
    SubjectComponent,
  },
})
export default class SubjectContainer extends Vue {
  @Prop()
  subjects!: SubjectBlock[];

  @Prop()
  isLoading!: boolean;

  @Prop()
  subjectType!: SubjectType;

  subjectClicked(subject: SubjectBlock) {
    this.$emit('openSubjectModal', {
      subject,
      subjectType: this.subjectType,
    });
  }
}
